export const clearDeposit = async ({ commit }) => {
    commit('setDepositCreated', false);
    commit("setDeposit", {
        code: 0,
        result: {},
    });
};
